module.exports = __webpack_public_path__ + "static/media/Holly Orefice Headshot.7eb98840.jpeg";